// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestReopenBody = {
  poolId: string;
  contestId: string;
};

export type typeContestReopenOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contestId: string;
    status: "reopened";
    reopenedAt: string;
    reopenCount: number;
  };
};

export type typeContestReopenOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestReopenOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestReopenOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestReopenBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "contestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestReopen(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestReopenBody);
  }

  return async function postContestReopen(
    payload: typeContestReopenBody,
  ): Promise<typeContestReopenOutput200 | typeContestReopenOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestReopen" failed before calling the network. #75f610a28ce8`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#75f610a28ce8" },
        },
        data: null,
      } as typeContestReopenOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/reopen`,
      httpMethod: "POST",
      options,
    })) as typeContestReopenOutput200 | typeContestReopenOutput400;
  };
}
